import React, { Component } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { Row, Col, Card, CardBody } from "reactstrap";
import { isUserAuthenticated } from "helpers/authUtils";
import { Spinner } from "reactstrap";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { googleLoginRequest, facebookLoginRequest } from "store/actions";
import { compose } from "redux";
import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import loginReducer from "store/Auth/Login/reducer";
import loginSaga from "store/Auth/Login/saga";
import { makeLoginSelectField } from "store/Auth/Login/selector";
import { createStructuredSelector } from "reselect";
import { createLoadingSelector } from "store/Shared/selector";
import logoRoundedImg from "images/logo-rounded.png";
import { FACEBOOK_APP_ID, GOOGLE_CLIENT_ID } from "constants/config";

// import LoginForm from "./LoginForm";
// import LoginVerificationForm from "./LoginVerificationForm";

const loginKey = "Login";

const withLoginReducer = injectReducer({
  key: loginKey,
  reducer: loginReducer,
});
const withLoginSaga = injectSaga({ key: loginKey, saga: loginSaga });

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoginVerificationForm: false,
      googleLoginReady: false,
      error: {
        isError: false,
        message: "",
      },
    };
    document.body.classList.add("bg-primary");

    if (props.location.query && props.location.query.isLogout) {
      // call logout API
      this.props.logoutRequest();
    } else {
      if (isUserAuthenticated() === true) {
        this.props.history.replace("/dashboard");
      }
    }
  }

  componentDidMount() {
    window.googleLogin = (tokenId) => {
      this.googleResponse({ tokenId });
    };
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (nextprops.loginUser && this.props.loginUser !== nextprops.loginUser) {
      this.props.history.replace("/dashboard");
    }

    if (
      nextprops.loginApiResponse &&
      this.props.loginApiResponse !== nextprops.loginApiResponse
    ) {
      if (nextprops.loginApiResponse.isSuccessResponse) {
        this.setState({
          isLoginVerificationForm: true,
          error: {
            isError: false,
            message: nextprops.loginApiResponse.responseMessage,
          },
        });
      } else {
        this.setState({
          error: {
            isError: true,
            message: nextprops.loginApiResponse.responseMessage,
          },
        });
      }
    }
  }

  googleResponse = (response) => {
    if (!response.credential) {
      this.setState({
        error: {
          isError: true,
          message: "Unable to login from Google",
        },
      });
      return;
    }
    this.props.googleLoginRequest({
      token: response.credential,
    });
  };

  facebookResponse = (response) => {
    if (!response.accessToken) {
      this.setState({
        error: {
          isError: true,
          message: "Unable to login from Facebook",
        },
      });
      return;
    }

    this.props.facebookLoginRequest({
      token: response.accessToken,
    });
  };

  changeNumberHandler = () => {
    this.setState({
      isLoginVerificationForm: false,
      error: {
        isError: false,
        message: "",
      },
    });
  };

  render() {
    let responseClass = "text-center mb-4";
    if (!this.state.error.isError) {
      responseClass += " text-success";
    } else {
      responseClass += " text-danger";
    }
    return (
      <React.Fragment>
        {this.props.loadingSelector && (
          <div className="loader">
            <Spinner color="white" />
          </div>
        )}
        <GoogleOAuthProvider
          clientId={GOOGLE_CLIENT_ID}
          onScriptLoadSuccess={() => this.setState({ googleLoginReady: true })}
        >
          <div className="login-page">
            <div className="container">
              <Row className="justify-content-center">
                <Col md="8" lg="6" xl="5">
                  <Card className="bg-pattern shadow-none">
                    <CardBody>
                      <div className="p-3">
                        <div className="text-center mt-4">
                          <div className="mb-3">
                            <div className="logo">
                              <img
                                src={logoRoundedImg}
                                height="100"
                                alt="logo"
                              />
                            </div>
                          </div>
                        </div>
                        <h4 className="font-18 text-center">Login</h4>
                        <p className={responseClass}>
                          {this.state.error.message}
                        </p>

                        {/* {this.state.isLoginVerificationForm
                                                  ? <LoginVerificationForm onChangeNumber={this.changeNumberHandler} />
                                                  : <LoginForm />
                                              } */}

                        <div className="mt-4 text-center">
                          {/* <span>OR</span> */}
                          <div className="mt-3 d-flex row justify-content-around align-items-center">
                            <div className="mb-2">
                              {this.state.googleLoginReady && (
                                <GoogleLogin
                                  text="Google Login"
                                  logo_alignment="left"
                                  onSuccess={this.googleResponse}
                                  onError={this.googleResponse}
                                />
                              )}
                            </div>
                            <FacebookLogin
                              appId={FACEBOOK_APP_ID}
                              textButton="Facebook Login"
                              version="3.1"
                              disableMobileRedirect
                              render={(renderProps) => (
                                <button
                                  onClick={renderProps.onClick}
                                  className="btn facebook-btn mb-2"
                                >
                                  <i className="fab fa-facebook-f fa-md mr-3"></i>
                                  Facebook Login
                                </button>
                              )}
                              callback={this.facebookResponse}
                              onFailure={this.facebookResponse}
                            />
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="mt-5 text-center text-white-50">
                    <p>© {new Date().getFullYear()} Mangal Deep Family Shop</p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </GoogleOAuthProvider>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  loginUser: makeLoginSelectField("loginUser"),
  loginApiResponse: makeLoginSelectField("loginApiResponse"),
  loadingSelector: createLoadingSelector(),
});

const withConnect = connect(mapStatetoProps, {
  googleLoginRequest,
  facebookLoginRequest,
});

export default compose(
  withConnect,
  withLoginReducer,
  withLoginSaga,
  withRouter
)(Index);
